import { CashFlowPaymentTypeEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function cashFlowPaymentTypeNameFilter(paymentType: CashFlowPaymentTypeEnum) {
  switch (paymentType) {
    case CashFlowPaymentTypeEnum.Cash: return i18n.t(LF.Cash) as string;
    case CashFlowPaymentTypeEnum.Transfer: return i18n.t(LF.Transfer) as string;
    case CashFlowPaymentTypeEnum.AdvancePaymentCash: return i18n.t(LF.AdvancePaymentCash) as string;
    case CashFlowPaymentTypeEnum.AdvancePaymentTransfer: return i18n.t(LF.AdvancePaymentTransfer) as string;
    default: return '';
  }
}
